import { getFingerPrint } from "../utilities";
import { OperationRequestData } from "./operationRequestData";

/**
 * Класс данных реквизитов счёта.
 */
export class OperationFingerPrintLogData {

  /**
   * имя операции.
   */
  public OperationName: string = "";
  
  /**
   * данные операции.
   */
  public OperationRequest: string = "";
  
  /**
   * идентификатор операции.
   */
  public OperationId: number = 0;
  
  /**
   * Данные цифрового отпечаткаю.
   */
  public FingerPrintData: string = "";
  
  /**
   * Источник запроса
   */
  public TypeSource: number = 0;

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  public constructor(name: string, operationRequest: string = '', ord: any = null) {
    this.OperationName = name ?? '';
    this.FingerPrintData = JSON.stringify(getFingerPrint());
    if (operationRequest.length > 0 && ord === null) {
      this.OperationRequest = operationRequest ?? '';
    } else if (ord !== null) {
      this.OperationRequest = JSON.stringify(ord);
    }
  }
}
